import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";

class SelectFieldComponent extends Component {
  static propTypes = {
    values: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ).isRequired,
    label: PropTypes.string,
    translatedLabel: PropTypes.string,
    intl: intlShape.isRequired,
    input: PropTypes.object,
    defaultSelect: PropTypes.string,
    meta: PropTypes.shape({
      error: PropTypes.string,
      warning: PropTypes.string,
      touched: PropTypes.bool
    })
  };

  render() {
    const {
      label,
      values,
      translatedLabel,
      intl,
      input,
      defaultSelect,
      meta: { touched, error, warning }
    } = this.props;

    const labelToUse =
      translatedLabel || label
        ? translatedLabel || intl.formatMessage({ id: label })
        : "";
    const translatedDefaultSelect = defaultSelect
      ? intl.formatMessage({ id: defaultSelect })
      : "";

    return (
      <div className="SelectField">
        {labelToUse && <label>{labelToUse}</label>}
        <div>
          <select {...input}>
            {translatedDefaultSelect && (
              <option value="" disabled hidden>
                {translatedDefaultSelect}
              </option>
            )}
            {values.map(item => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          {touched &&
            ((error && (
              <span>
                <FormattedMessage id={error} />
              </span>
            )) ||
              (warning && (
                <span>
                  <FormattedMessage id={warning} />
                </span>
              )))}
        </div>
      </div>
    );
  }
}

const SelectField = props => (
  <Field component={SelectFieldComponent} {...props} />
);

export default injectIntl(SelectField);



// WEBPACK FOOTER //
// ./src/modules/forms/fields/select-field.js